<igo-list [navigation]="true">
  <div class="context-filter-container">
    @if (showFilter()) {
      <mat-form-field>
        <mat-label>{{
          'igo.context.contextManager.filterPlaceHolder' | translate
        }}</mat-label>
        <input
          matInput
          type="text"
          [placeholder]="
            'igo.context.contextManager.filterPlaceHolder' | translate
          "
          [(ngModel)]="term"
        />
        @if (term.length) {
          <button
            mat-icon-button
            matSuffix
            class="clear-button"
            aria-label="Clear"
            color="warn"
            (click)="clearFilter()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <div class="actions-container">
      <button
        mat-icon-button
        [matTooltip]="
          sortedAlpha
            ? ('igo.context.contextManager.sortDefault' | translate)
            : ('igo.context.contextManager.sortAlphabetically' | translate)
        "
        matTooltipShowDelay="500"
        (click)="toggleSort()"
      >
        <igo-icon
          color="primary"
          [icon]="sortedAlpha ? sortAlphaOnIcon : sortAlphaOffIcon"
        />
      </button>

      @if (auth.authenticated && contextConfigs) {
        <igo-actionbar
          class="add-context-button"
          [iconColor]="color"
          [store]="actionStore"
          [withIcon]="true"
          icon="add"
          [withTitle]="actionbarMode === 'overlay'"
          [horizontal]="false"
          [mode]="actionbarMode"
        />

        <button
          class="users-filter"
          mat-icon-button
          [matTooltip]="'igo.context.contextManager.filterUser' | translate"
          matTooltipShowDelay="500"
          [matMenuTriggerFor]="accountMenu"
        >
          <mat-icon color="primary">filter_alt</mat-icon>
        </button>
      }
      <mat-menu #accountMenu="matMenu">
        @for (user of users; track user.name) {
          @if (!user.childs) {
            <button mat-menu-item class="profil-menu">
              <mat-checkbox
                [checked]="getPermission(user).checked"
                [indeterminate]="getPermission(user).indeterminate"
                (click)="$event.stopPropagation()"
                (change)="handleToggleCategory(user)"
              />
              <span>{{ user.title }}</span>
            </button>
          } @else {
            <button
              mat-menu-item
              [matMenuTriggerFor]="subAccountMenu"
              class="profil-menu"
            >
              <mat-checkbox
                [checked]="getPermission(user).checked"
                [indeterminate]="getPermission(user).indeterminate"
                (click)="$event.stopPropagation()"
                (change)="handleToggleCategory(user)"
              />
              <span>{{ user.title }}</span>
            </button>
            <mat-menu #subAccountMenu="matMenu">
              @for (child of user.childs; track child.name) {
                <button mat-menu-item class="profil-menu">
                  <mat-checkbox
                    [checked]="getPermission(child).checked"
                    (click)="$event.stopPropagation()"
                    (change)="handleToggleCategory(child, user)"
                  >
                    {{ child.title }}
                  </mat-checkbox>
                </button>
              }
            </mat-menu>
          }
        }

        <button mat-menu-item class="profil-menu">
          <mat-checkbox
            [checked]="showHidden"
            (click)="$event.stopPropagation()"
            (change)="onShowHiddenContexts()"
          />
          <span>
            {{ 'igo.context.contextManager.showHidden' | translate }}
          </span>
        </button>
      </mat-menu>
    </div>
  </div>

  @for (
    groupContexts of $any(contexts$ | async) | keyvalue: sortByKeyPriority;
    track groupContexts
  ) {
    @if ($any(groupContexts).value.length) {
      @if (auth.authenticated) {
        <igo-collapsible
          [title]="titleMapping[$any(groupContexts).key] | translate"
          [collapsed]="$any(collapsed[titleMapping[$any(groupContexts).key]])"
          (toggle)="
            collapsed[titleMapping[$any(groupContexts).key]] = $any($event)
          "
        >
          @for (
            context of $any(groupContexts).value;
            track context.id ?? context.uri
          ) {
            <igo-context-item
              igoListItem
              color="accent"
              [selected]="
                selectedContext() && selectedContext().uri === context.uri
              "
              [context]="context"
              [default]="
                context.id &&
                this.defaultContextId &&
                this.defaultContextId === context.id
              "
              [isDesktop]="isDesktop"
              (edit)="onEdit(context)"
              (delete)="onDelete(context)"
              (clone)="onClone(context)"
              (save)="onSave(context)"
              (hide)="onHideContext(context)"
              (show)="showContext(context)"
              (favorite)="onFavorite(context)"
              (manageTools)="onManageTools(context)"
              (managePermissions)="onManagePermissions(context)"
              (select)="onSelect(context)"
              (unselect)="unselect.emit(context)"
              (share)="onShareContext(context)"
            />
          }
        </igo-collapsible>
      } @else {
        @for (
          context of $any(groupContexts).value;
          track context.id ?? context.uri
        ) {
          <igo-context-item
            igoListItem
            color="accent"
            [showFavorite]="
              configService.getConfig('favoriteContext4NonAuthenticated')
            "
            [selected]="isContextSelected(context)"
            [context]="context"
            [default]="
              contextConfigs
                ? defaultContextId === context.id
                : defaultContextId === context.uri
            "
            [isDesktop]="isDesktop"
            (edit)="onEdit(context)"
            (delete)="onDelete(context)"
            (clone)="onClone(context)"
            (save)="onSave(context)"
            (hide)="onHideContext(context)"
            (show)="showContext(context)"
            (favorite)="onFavorite(context)"
            (select)="onSelect(context)"
            (unselect)="unselect.emit(context)"
          />
        }
      }
    }
  }

  @if (isEmpty) {
    <div class="no-result">
      {{ 'igo.context.contextManager.noResult' | translate }}
    </div>
  }
</igo-list>
